export const logoConfig = {
    MAX_WIDTH: 290,
    MAX_HEIGHT: 50,
};

export const brandingTerms = {
    branding: 'Branding',
    profileTabTitle: appName => `Logo for ${appName} PDF Reports`,
    profileTabDescription: 'Insert a logo that you would like to include in your PDF reports.',
    addLogoButton: 'Add Logo',
    updateLogoButton: 'Update Logo',
    removeLogoButton: 'Remove Logo',
    profileTabFileTitle: 'File size and accepted formats',
    profileTabFileDescription: `Only one file can be uploaded. The size limit is 2MB. Recommended width: ${logoConfig.MAX_WIDTH}px, height: ${logoConfig.MAX_HEIGHT}px. Accepted file formats include .jpg, and .png.`,
    addLogo: 'Add your Logo',
    removeLogoModal: {
        title: 'Remove Logo',
        body: 'Removing the logo will exclude it from generated PDF reports. Add a logo to ensure it appears on your PDFs.',
        cancelButton: 'Cancel',
        confirmButton: 'Ok'
    },
    updateLogoModal: {
        title: 'Update Logo',
        body: 'Uploading this logo will replace your current logo. Are you sure you want to proceed?',
        cancelButton: 'Cancel',
        confirmButton: 'Ok'
    },
    errorMessages: {
        logoDeleteError: 'Error deleting logo:',
        logoUploadError: 'Error uploading logo:',
    }
};

export const uploaderConfig = {
    maxLogoFileSizeInBytes: 2 * 1024 * 1024, // 2MB
    allowedLogoFileTypes: ['.jpg', '.jpeg', '.png'],
    maxNumberOfLogoFiles: 1,
};
